<template>
	<div>
		<practice-request-sent />
		<practice-upcoming-bookings />
		<practice-booking-history />

		<practice-applications-received />
		<practice-created-offers />
	</div>
</template>

<script>
import PracticeRequestSent from '@/components/ui/dashboard/practice/cards/PracticeRequestSent';
import PracticeUpcomingBookings from '@/components/ui/dashboard/practice/dropdowns/PracticeUpcomingBookings';
import PracticeBookingHistory from '@/components/ui/dashboard/practice/dropdowns/PracticeBookingHistory';

import PracticeCreatedOffers from '@/components/ui/dashboard/practice/dropdowns/PracticeCreatedOffers';
import PracticeApplicationsReceived from '@/components/ui/dashboard/practice/dropdowns/PracticeApplicationsReceived';

export default {
	name: 'PracticeSuccessRequestSent',
	components: {
		PracticeRequestSent,
		PracticeUpcomingBookings,
		PracticeBookingHistory,
		PracticeCreatedOffers,
		PracticeApplicationsReceived,
	},
	data: () => ({}),
};
</script>
